import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLetter = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.168 16.712H3.499V7.29h16.535l.589-.589H2.91v10.601h18.847V10.78l-.59.589v5.344Z"
        fill="#374151"
      />
      <path
        d="M15.867 12.295v1.767h1.767l5.89-5.89-1.767-1.767-5.89 5.89Zm1.531 1.178h-.942v-.943l4.476-4.476.943.943-4.477 4.476Zm4.889-4.889-.942-.942.412-.412.942.942-.412.412ZM15.278 13.473H7.916v.589h7.362v-.59ZM15.278 12.295H7.916v.589h7.362v-.59ZM16.162 11.117H7.917v.59h7.656l.589-.59ZM7.327 8.172H4.382v.589h2.945v-.59Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgLetter;
